import React from "react";
import { Button, Form, FormGroup, Input, Label, Alert, Spinner } from "reactstrap";
import axios from "axios";
import Select, { createFilter } from "react-select";
import { API_URL_productos, API_URL_product_types } from "../../constants";
import ProductTypeManagerModal from "./ProductTypeManagerModal";

import { getAuthHeaders } from "../../utils/auth";
class NewProductoForm extends React.Component {

  // Default types used as a fallback if the /api/product_types/ fetch
  // fails (network error, backend not yet deployed, etc). Kept in the
  // same order as the seed migration.
  static FALLBACK_TIPO_OPTIONS = [
    { value: "Curso", label: "Curso" },
    { value: "Taller", label: "Taller" },
    { value: "Asesoría", label: "Asesoría" },
    { value: "Libro digital", label: "Libro digital" },
    { value: "Material impreso", label: "Material impreso" },
    { value: "Material Digital", label: "Material Digital" },
    { value: "Licencia", label: "Licencia" },
    { value: "Otros", label: "Otros" },
  ];

  state = {
    pk: 0,
    producto_code: "",
    nombre: "",
    tipo: "",
    tipoOptions: NewProductoForm.FALLBACK_TIPO_OPTIONS,
    tipoManagerOpen: false,
    errorMessage: '',
    validationErrors: {},
    isSubmitting: false,
  };

  fetchTipoOptions = async () => {
    try {
      const res = await axios.get(API_URL_product_types, { headers: getAuthHeaders() });
      const opts = (res.data || [])
        .filter((t) => t && t.nombre)
        .map((t) => ({ value: t.nombre, label: t.nombre }));
      if (opts.length) this.setState({ tipoOptions: opts });
    } catch (err) {
      // Silent fallback — the state already holds FALLBACK_TIPO_OPTIONS.
      console.warn('Could not load product types, using fallback list.', err);
    }
  };

  componentDidMount() {
    this.fetchTipoOptions();
    if (this.props.producto) {
      const {
      pk,
      producto_code,
      nombre,
      tipo,


      } = this.props.producto;
      this.setState({
        pk,
        producto_code,
        nombre,
        tipo,
      });
    }
  }

  onChange = e => {
    this.setState({ [e.target.name]: e.target.value });
  };

  validateForm = () => {
    const errors = {};
    const { nombre, tipo } = this.state;

    if (!nombre || nombre.trim() === '') {
      errors.nombre = 'Por favor ingresa el nombre del producto';
    }

    if (!tipo || tipo.trim() === '') {
      errors.tipo = 'Por favor selecciona un tipo de producto';
    }

    this.setState({ validationErrors: errors });
    return Object.keys(errors).length === 0;
  };

  createProducto = e => {
    e.preventDefault();

    if (!this.validateForm()) {
      this.setState({ errorMessage: 'Por favor completa todos los campos obligatorios marcados con *' });
      setTimeout(() => {
        const firstError = document.querySelector('.is-invalid');
        if (firstError) {
          firstError.scrollIntoView({ behavior: 'smooth', block: 'center' });
          firstError.focus();
        }
      }, 100);
      return;
    }

    this.setState({ isSubmitting: true, errorMessage: '' });

    const headers = getAuthHeaders();
    axios.post(API_URL_productos, this.state, { headers })
    .then(() => {
      this.props.resetState();
      this.props.toggle();
    }).catch(error => {
      console.log(error);
      if (error.response?.data) {
        const serverErrors = error.response.data;
        if (typeof serverErrors === 'object' && !Array.isArray(serverErrors)) {
          this.setState({ validationErrors: serverErrors, isSubmitting: false });
        } else {
          this.setState({
            errorMessage: 'Error al crear el producto. Por favor verifica los datos.',
            isSubmitting: false
          });
        }
      } else {
        this.setState({
          errorMessage: 'Error de conexión. Por favor intenta nuevamente.',
          isSubmitting: false
        });
      }
    });
  };

  editProducto = e => {
    e.preventDefault();

    if (!this.validateForm()) {
      this.setState({ errorMessage: 'Por favor completa todos los campos obligatorios marcados con *' });
      setTimeout(() => {
        const firstError = document.querySelector('.is-invalid');
        if (firstError) {
          firstError.scrollIntoView({ behavior: 'smooth', block: 'center' });
          firstError.focus();
        }
      }, 100);
      return;
    }

    this.setState({ isSubmitting: true, errorMessage: '' });

    const headers = getAuthHeaders();
    axios.put(API_URL_productos + this.state.pk, this.state, { headers })
    .then(() => {
      this.props.resetState();
      this.props.toggle();
    }).catch(error => {
      console.log(error);
      if (error.response?.data) {
        const serverErrors = error.response.data;
        if (typeof serverErrors === 'object' && !Array.isArray(serverErrors)) {
          this.setState({ validationErrors: serverErrors, isSubmitting: false });
        } else {
          this.setState({
            errorMessage: 'Error actualizando el producto. Por favor verifica los datos.',
            isSubmitting: false
          });
        }
      } else {
        this.setState({
          errorMessage: 'Error de conexión. Por favor intenta nuevamente.',
          isSubmitting: false
        });
      }
    });
  };

  defaultIfEmpty = value => {
    return value === "" ? "" : value;
  };

  render() {

    const { errorMessage, tipo, validationErrors, isSubmitting } = this.state;

    // Filter option for react-select (search without accents)
    const filterOption = createFilter({
      ignoreAccents: true,
      ignoreCase: true,
      trim: true,
      matchFrom: "any",
    });

    // Options for Select components. Loaded from /api/product_types/ on
    // mount by fetchTipoOptions — the FALLBACK_TIPO_OPTIONS static field
    // seeds the state so the form is usable while the request is in flight.
    const tipoOptions = this.state.tipoOptions;

    return (
      <Form onSubmit={this.props.producto ? this.editProducto : this.createProducto}>
        <p style={{ fontSize: '0.9em', color: '#007bff', marginBottom: '1rem' }}>
          Los campos marcados con <span style={{ color: 'red' }}>*</span> son obligatorios
        </p>

        <FormGroup>
          <div style={{ display: 'flex', alignItems: 'baseline', justifyContent: 'space-between' }}>
            <Label for="tipo" style={{ marginBottom: 0 }}>
              Tipo: <span style={{ color: 'red' }}>*</span>
            </Label>
            <button
              type="button"
              onClick={() => this.setState({ tipoManagerOpen: true })}
              style={{
                background: 'transparent',
                border: 'none',
                color: '#6b7280',
                fontSize: '0.8125rem',
                fontWeight: 500,
                padding: 0,
                cursor: 'pointer',
                textDecoration: 'underline',
                textDecorationStyle: 'dotted',
                textUnderlineOffset: 2,
              }}
            >
              Administrar tipos
            </button>
          </div>
          <Select
            options={tipoOptions}
            value={tipoOptions.find((o) => o.value === tipo) || null}
            onChange={(opt) => this.setState({
              tipo: opt ? opt.value : "",
              validationErrors: { ...validationErrors, tipo: null },
            })}
            placeholder="Selecciona tipo"
            isClearable
            filterOption={filterOption}
            styles={validationErrors.tipo ? { control: (base) => ({ ...base, borderColor: '#dc3545' }) } : undefined}
          />
          {validationErrors.tipo && (
            <div className="invalid-feedback d-block">{validationErrors.tipo}</div>
          )}
          <ProductTypeManagerModal
            isOpen={this.state.tipoManagerOpen}
            toggle={() => this.setState({ tipoManagerOpen: !this.state.tipoManagerOpen })}
            onSaved={this.fetchTipoOptions}
          />
        </FormGroup>
        <FormGroup>
          <Label for="nombre">Producto: <span style={{ color: 'red' }}>*</span></Label>
          <Input
            type="text"
            name="nombre"
            onChange={this.onChange}
            value={this.defaultIfEmpty(this.state.nombre)}
            invalid={!!validationErrors.nombre}
          />
          {validationErrors.nombre && (
            <div className="invalid-feedback d-block">{validationErrors.nombre}</div>
          )}
        </FormGroup>

        {errorMessage && <Alert color="danger">{errorMessage}</Alert>}

        <Button color="primary" disabled={isSubmitting}>
          {isSubmitting ? (
            <>
              <Spinner size="sm" className="me-2" /> Guardando...
            </>
          ) : (
            this.props.producto ? "Actualizar Producto" : "Crear Producto"
          )}
        </Button>
      </Form>
    );
  }
}

export default NewProductoForm;
